import { createField } from "./sampling-info.section";
import store from "../../../../../../store";
import lodash from "lodash";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const itemKey = props.itemKey;
    const isLoading = props.isLoading;
    data.fields = createField({ props, data, refs, key, itemKey, isLoading });
};

export const createForm = () => {
    return {
            samplingDatetime: null,
            refOperation: null,
            manufactureDate: null,
            manufactureExpireDate: null,
            manufacturer: null,
            importer: null,
            distributor: null,
            size: null,
            refSizeUnit: null,
            qty: null,
            refQtyUnit: null,
    };
};

export const initDefaultForm = ({ props, data, key }) => {
    const { informProduct } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    if (!model.id) {
        model.refDepartment = modelRef.refReleaseTemp?.refDepartment;
        model.refUserCompany = modelRef.refReleaseTemp?.refUserCompany;
        model.refUser = modelRef.refReleaseTemp?.refUser;
        model.refOfficer = lodash.cloneDeep(store.state.resource.auth.info?.user);
        if (modelRef.refReleaseTemp?.refInspection?.refInformTemp?.refOperation) {
            model.refOperation = modelRef.refReleaseTemp?.refInspection?.refInformTemp?.refOperation;
        }
        if (informProduct?.manufacturer) {
            model.manufacturer = informProduct?.manufacturer;
        }
        const companyNameTh = modelRef.refReleaseTemp?.refUserCompany?.companyNameTh;
        if (modelRef.refReleaseTemp?.refUserCompany?.refPersonType?.key === "1" && companyNameTh) {
            model.importer = companyNameTh;
        } else if (modelRef.refReleaseTemp?.refUserCompany?.fullNameTh) {
            model.importer = modelRef.refReleaseTemp?.refUserCompany?.fullNameTh;
        }
        const distributors = informProduct?.refHaz?.distributors;
        if (distributors?.length) {
            model.distributor = distributors.map(d => d?.refDistributor?.refPersonType?.key === "1" ? d.refDistributor?.companyNameTh : d.refDistributor?.fullNameTh)?.join(', ');
            model.distributors = distributors?.map(d => ({ refDistributor: d.refDistributor, isSave: true }));
        }
    }
    return model;
}